export default __webpack_public_path__ + "static/google-reviews-dd9b7eeb707c3b423671745a5a60a61b.svg";